<template>
  <div
    class="flex h-full w-full flex-col justify-between space-y-4 rounded-lg bg-ontick-steel-100 px-4 py-6 dark:bg-ontick-graphite-500 dark:shadow-xl"
  >
    <span
      class="text-sm font-bold text-ontick-carbon-900 dark:text-gray-400 xs:text-base"
      >Investimentos</span
    >
    <div class="">
      <div
        class="flex items-center divide-x-4 divide-ontick-steel-400 text-lg font-bold text-ontick-steel-400 sm:text-2xl xs:text-xl"
      >
        <span
          class="pr-2 text-2xl text-ontick-carbon-900 dark:text-gray-200 sm:text-4xl xs:text-3xl"
          >500</span
        ><span class="pl-2">500</span>
      </div>
      <span
        class="leading-1 text-xs text-ontick-steel-400 dark:text-gray-500 sm:whitespace-nowrap"
      >
        Estratégias executando
      </span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
